import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import { TeamPermission } from '@/graphql/generated/types.generated';
import { useTeamPermissions } from '@/providers/team-permissions-provider';
import AddCompetitorDialog from './AddCompetitorDialog';

export interface AddCompetitorProps {
    onClose?: (refreshList: boolean) => void;
    compact?: boolean;
}

export default function AddCompetitor(props: AddCompetitorProps) {
    const { onClose, compact } = props;
    const [open, setOpen] = useState(false);
    const { teamPermissions } = useTeamPermissions();
    const { t } = useTranslation();

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = (refreshList: boolean = false) => {
        onClose && onClose(refreshList);
        setOpen(false);
    };

    const hasCrudCompetitorsPerm = teamPermissions.includes(TeamPermission.CrudCompetitors);

    if (!hasCrudCompetitorsPerm) {
        return null;
    }

    return (
        <>
            <Button
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<AddRounded />}
                sx={{
                    borderRadius: '99px',
                    ...(compact && { minWidth: 0, '& .MuiButton-startIcon': { mr: 0 } }),
                }}
                onClick={handleOpenDialog}
                data-id="add-competitor"
                {...(compact && {
                    'aria-label': t('str.action.add-competitor'),
                    title: t('str.action.add-competitor'),
                })}
            >
                {!compact && t('str.action.add-competitor')}
            </Button>
            <AddCompetitorDialog onClose={handleCloseDialog} open={open} />
        </>
    );
}
